/**
 * SERP overrides for high-impression / low-CTR blog & FAQ pages.
 * Keys are normalized DB titles (lowercase, trailing ? stripped).
 * DB rows stay the lookup source of truth; these only improve <title>/meta.
 */

function normalizeKey(title) {
  let t = String(title || '')
    .trim()
    .toLowerCase()
  while (t.endsWith('?')) {
    t = t.slice(0, -1).trimEnd()
  }
  return t
}

const BLOG_SEO = {
  [normalizeKey(
    'Navigating East Coast Ice | A Guide to Choosing the Perfect Snowboard'
  )]: {
    title:
      'East Coast Ice Snowboard Guide | Magne-Traction & Aggressive Boards | SimplyBuy',
    description:
      'Choose a snowboard for East Coast ice: edge hold, Magne-Traction, camber, and aggressive setups. Then use SimplyBuy’s free snowboard picker to get a personalized board match.',
    ctaTopic: 'snowboard',
    ctaLabel: 'Snowboard Finder',
  },
  [normalizeKey(
    'Should I Get A Snowboard With Magne Traction Or Any Other Edge Tech?'
  )]: {
    title:
      'Magne-Traction & Edge Tech Explained | Should Your Snowboard Have It? | SimplyBuy',
    description:
      'What Magne-Traction and other edge tech actually do on ice and hardpack — and when to skip them. Finish with SimplyBuy’s snowboard picker for a board matched to your terrain.',
    ctaTopic: 'snowboard',
    ctaLabel: 'Snowboard Finder',
  },
}

const FAQ_SEO = {
  [normalizeKey('Is 4K worth it for a smaller TV?')]: {
    title: 'Is 4K Worth It on a Smaller TV? | Clear Answer | SimplyBuy',
    description:
      'When 4K matters on TVs under ~40–50″ — viewing distance, content, and gaming. Then use SimplyBuy’s TV picker to find the right set for your room and budget.',
  },
  [normalizeKey('What is the difference between 4K and 8K TVs?')]: {
    title: '4K vs 8K TVs: What’s Worth Buying Today? | SimplyBuy',
    description:
      '4K vs 8K in plain English — content availability, cost, and who should wait. Get a personalized TV match with SimplyBuy’s free TV picker.',
  },
}

export function getBlogSeo(title) {
  return BLOG_SEO[normalizeKey(title)] || null
}

export function getFaqSeo(question) {
  return FAQ_SEO[normalizeKey(question)] || null
}
